//#region src/schema/localization/locales/fr.ts
var e = {
	schema: {
		noAllowedValues: "Aucune valeur ne satisfait cette contrainte enum.",
		example: "Exemple",
		examples: "Exemples",
		default: "Par défaut",
		schema: "Schéma",
		emptyObject: "Objet vide",
		showAdditionalProperties: "Afficher les propriétés supplémentaires",
		showOneMoreProperty: "Afficher 1 propriété supplémentaire",
		showMoreProperties: "Afficher {count} propriétés supplémentaires",
		forName: "pour {name}",
		showSchemaDetails: "Afficher les détails du schéma",
		oneOf: "Un parmi",
		anyOf: "N’importe lequel parmi",
		allOf: "Tous parmi",
		not: "Non",
		unknownType: "type inconnu",
		propertyCount: "Propriétés : {count}",
		headerCount: "En-têtes : {count}",
		recursiveReference: "Référence récursive vers {name}",
		recursive: "récursif",
		additionalProperties: "propriétés supplémentaires",
		const: "constante",
		deprecated: "obsolète",
		discriminator: "Discriminateur",
		enum: "enum",
		format: "Format",
		greaterThan: "supérieur à",
		keys: "clés",
		lessThan: "inférieur à",
		max: "max.",
		min: "min.",
		maxLength: "longueur max.",
		minLength: "longueur min.",
		multipleOf: "multiple de",
		nullable: "nullable",
		propertyNames: "noms des propriétés",
		pattern: "Motif",
		copyPattern: "Copier le motif",
		readOnly: "lecture seule",
		required: "obligatoire",
		hideValues: "Masquer les valeurs",
		showAllValues: "Afficher toutes les valeurs",
		type: "Type",
		unique: "unique",
		values: "valeurs",
		writeOnly: "écriture seule"
	},
	common: {
		copyDefault: "Copier la valeur par défaut",
		copyExample: "Copier la valeur d’exemple"
	},
	actions: { copyLinkTo: "Copier le lien vers {name}" }
};
//#endregion
export { e as fr };

//# sourceMappingURL=fr.js.map